/* Publish by EComposer at 2026-10-07 19:26:42*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8qdavepy536"]=  window.__ectimmers["ecom-8qdavepy536"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8qdavepy536').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qdavepy536', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qatnfph5clk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qatnfph5clk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qowgv70k33j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qowgv70k33j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ey9198r3mho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ey9198r3mho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kr9zi74zskc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kr9zi74zskc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jav2fwls9mf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jav2fwls9mf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3kg3e7bb4ra').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3kg3e7bb4ra', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifugoiujyoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifugoiujyoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dukj6g51e1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dukj6g51e1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5jz0fcmmgp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5jz0fcmmgp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xltvn23so5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xltvn23so5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cy7ciu5ef2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cy7ciu5ef2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9sxtmie11ph').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9sxtmie11ph', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-im7k2ywoga').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-im7k2ywoga', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nhbs1o8o48c"]=  window.__ectimmers["ecom-nhbs1o8o48c"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-nhbs1o8o48c"]["xzgi9nsj9"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-nhbs1o8o48c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhbs1o8o48c', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53kau92p83r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53kau92p83r', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8zaf5viu3sm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8zaf5viu3sm', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-08fi57u8alb3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-08fi57u8alb3', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6i7mqkjz4tt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6i7mqkjz4tt', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gy4y4ncucib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gy4y4ncucib', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o847afo3moq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o847afo3moq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o1g30eijlr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o1g30eijlr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rxh24izvjv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rxh24izvjv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pherlvukjw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pherlvukjw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t9lraq5ts4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t9lraq5ts4', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iyyt5thvev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iyyt5thvev', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fyl1rsy2jvh"]=  window.__ectimmers["ecom-fyl1rsy2jvh"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-fyl1rsy2jvh"]["gb4oiuk40"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-fyl1rsy2jvh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fyl1rsy2jvh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o0x8i5ky17').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o0x8i5ky17', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vo66tevfo7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vo66tevfo7c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0lzv0dilwij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0lzv0dilwij', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6tc0qepd076').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6tc0qepd076', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1eooshbeom1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1eooshbeom1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-feiyu6n2kgp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-feiyu6n2kgp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e00ngfk3huq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e00ngfk3huq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cfvjzonzqre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cfvjzonzqre', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qxsr0sfzc59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qxsr0sfzc59', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o2jg5d655ed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o2jg5d655ed', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-za7i459b8u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-za7i459b8u', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1weq445ijkx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1weq445ijkx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vr8s3882jd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vr8s3882jd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-46er4cca5wi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-46er4cca5wi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}